export const locationsContainer = {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  overflowY: 'scroll',
  width: '450px',
  paddingBottom: '2rem',
  maxHeight: '85vh',
};

export const locationsContainerMobile = {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  overflowY: 'scroll',
  width: '100%',
  paddingBottom: '1rem',
};

export const storeLocationContainer = {
  display: 'flex',
  flexDirection: 'row',
  height: '100%',
};

export const autocompleteInputId = 'enter-location';

export const markerContainer = {
  width: '100%',
  maxWidth: '200px',
  textAlign: 'left',
  marginTop: '.75rem',
  marginBottom: '.75rem',
  marginRight: '.5rem',
};

export const markerContent = {
  display: 'inline-block',
  marginTop: '.5rem',
};

export const addressStyles = {
  textDecoration: 'underline',
};

export const flexSection = {
  display: 'flex',
  marginTop: '.5rem',
};

export const distanceFlexSection = {
  display: 'flex',
  marginTop: '.5rem',
};

export const locationNameStyles = {
  marginBottom: '0',
  textAlign: 'left',
  textTransform: 'uppercase',
  paddingBottom: '.15rem',
  fontSize: '20px',
};

export const listItemSection = {
  marginBottom: '2rem',
  marginTop: '0',
  marginLeft: '2rem',
  marginRight: '2rem',
  textAlign: 'left',
};

export const labelStyles = { textAlign: 'left', marginBottom: '.25rem' };

export const searchContainerSection = {
  display: 'flex',
  flexDirection: 'column',
  margin: '2rem',
  flexShrink: '0',
};

export const searchResetSection = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
};

export const locationList = {
  marginBottom: '.75rem',
};

export const locationListItemHours = {
  padding: '',
  textAlign: 'left',
};

export const hardBreakStyles = {
  margin: '0px 2rem 2rem',
  width: 'initial',
  border: 'none',
  height: '1px',
};

export const searchErrorStyles = {
  marginTop: '.25rem',
};
